/// <reference types="@angular/localize" />

import { registerLocaleData } from '@angular/common';
import zhHant from '@angular/common/locales/zh-Hant';
import { computed, signal } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { $ } from '@ay-gosu-party/modules/signal';
import * as Sentry from '@sentry/angular-ivy';
import { Integration } from '@sentry/types';
import 'reflect-metadata';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

const { sentry } = environment;

if (sentry.enable) {
  const integrations: Integration[] = [];

  const browserTracing = sentry.browserTracing;
  if (browserTracing.enable) {
    const tracePropagationTargets = browserTracing.tracePropagationTargets;

    integrations.push(
      new Sentry.BrowserTracing({
        tracePropagationTargets,
        routingInstrumentation: Sentry.routingInstrumentation,
      }),
    );
  }

  const { dsn, release } = sentry;
  Sentry.init({ dsn, release, integrations, tracesSampleRate: 1.0 });
}

$.signal = signal;
$.computed = computed;

registerLocaleData(zhHant);
bootstrapApplication(AppComponent, appConfig).catch((err) => {
  console.error(err);
});
